import React from "react";

export const REDUCED_MOTION_QUERY = "(prefers-reduced-motion: reduce)";

/**
 * Whether the visitor asked for reduced motion. False during server rendering
 * and the first client render, then follows the media query.
 */
export const usePrefersReducedMotion = () => {
    const [reduced, setReduced] = React.useState(false);

    React.useEffect(() => {
        const query = window.matchMedia(REDUCED_MOTION_QUERY);
        const update = () => setReduced(query.matches);
        update();
        query.addEventListener("change", update);
        return () => query.removeEventListener("change", update);
    }, []);

    return reduced;
};
